import Vue from 'vue'
import ContextMenu from './ContextMenu.vue'

const ContextMenuConstructor = Vue.extend(ContextMenu)
const instance = new ContextMenuConstructor({
  el: document.createElement('div')
})

document.body.appendChild(instance.$el)

Vue.prototype.$contextmenu = instance

Vue.directive('context-menu', {
  inserted: function (el, binding, vnode) {
    let options = binding.value
    instance.menuOptions = options

    let openMenu = function (e) {
      instance.openMenu(options, e)
    }

    el.addEventListener('contextmenu', openMenu)
  }
})

export default instance



// WEBPACK FOOTER //
// ./src/components/ContextMenu/index.js